// extracted by mini-css-extract-plugin
export default {"AsidePanelItemDefault":"AsidePanelItem_AsidePanelItemDefault__5Krs1"};